/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Typ média PDF.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
class PdfOnlineViewerType {
  /**
   * Vytvoří instanci.
   * @param {PdfViewerControllerFactory} controllerFactory
   * @param {PdfViewerSourceCreator} sourceCreator
   */
  constructor(controllerFactory, sourceCreator) {
    this.controllerFactory = controllerFactory;
    this.sourceCreator = sourceCreator;
  }

  /** @inheritdoc */
  createController() {
    return this.controllerFactory.create();
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // PDF mají v detailu média nastavení "Kontrolovat aktuální verzi".
    // Hodnota se předává v parametrech média.
    return medium.params?.checkFile ?? false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    return false;
  }
}

export default PdfOnlineViewerType;
